import { Divider, Modal } from "@mui/material";
import countries from "../../../json/countriesDetailed.json";

const FastReceiverAddress = ({ status, setStatus, item, setAddress }) => {
  const handleClose = () => {
    setStatus(false);
  };

  return (
    <Modal
      open={status}
      onClose={handleClose}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center", outline: "none" }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--gap)",
          backgroundColor: "var(--lighterBg)",
          borderRadius: "var(--wrapperBorderRadius)",
          maxWidth: "480px",
          width: "100%",
          padding: "20px",
          maxHeight: "90vh",
          overFlowY: "auto",
        }}
      >
        <h2 style={{ fontSize: "20px" }}>Alıcı Adres Bilgileri</h2>
        <Divider />
        <div>
          <span style={{ fontWeight: 600 }}>Ad Soyad: </span>
          {item?.contact_name}
        </div>
        {item?.buyer_email && (
          <div>
            <span style={{ fontWeight: 600 }}>Mail Adresi: </span>
            {item?.buyer_email}
          </div>
        )}
        {item?.postal_code && (
          <div>
            <span style={{ fontWeight: 600 }}>Posta Kodu: </span>
            {item?.postal_code}
          </div>
        )}
        {item?.address1 && (
          <div className="list-item-select-child">
            <span style={{ fontWeight: 600 }}>Adres Satırı: </span>
            {item?.address1 && item?.address1} {item?.address2 && item?.address2}{" "}
            {item?.address3 && item?.address3}
          </div>
        )}
        {item?.city && (
          <div className="list-item-select-child">
            {" "}
            <span style={{ fontWeight: 600 }}>Şehir: </span>
            {item?.city}
          </div>
        )}
        {item?.state && (
          <div className="list-item-select-child">
            {" "}
            <span style={{ fontWeight: 600 }}>Eyalet Kodu: </span>
            {item?.state}
          </div>
        )}
        {item?.country && (
          <div className="list-item-select-child">
            {" "}
            <span style={{ fontWeight: 600 }}>Ülke: </span>
            {countries.find((e) => e.iso_code === item?.country).country_name_tr}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default FastReceiverAddress;
